import { useTranslation } from 'react-i18next';

import { cn } from '@muzly/lib/utils';

/**
 * 큰 점수 한 줄 — `78` (44px Bold) + `/ 100` (22px SemiBold, BK_400).
 * 홈 추세는 레드, 결과 상세는 검정으로 찍는다(시안 그대로).
 *
 * **점수가 없으면 `이번엔 못 쟀어요`**를 같은 자리에 둔다 — 0을 쓰지 않는다.
 */
export const ScoreHero = ({
  score,
  tone = 'ink',
  className,
}: {
  /** 0..100. null = 못 쟀다. */
  score: number | null;
  tone?: 'ink' | 'primary';
  className?: string;
}) => {
  const { t } = useTranslation();
  if (score == null) {
    return (
      <p className={cn('text-base font-semibold text-bk-600', className)}>
        {t('web.result.pending')}
      </p>
    );
  }
  return (
    <p
      data-testid="score-hero"
      className={cn('flex items-end gap-2.5 leading-none', className)}
    >
      <span
        className={cn(
          'text-[44px] font-bold tracking-[-0.22px] tabular-nums',
          tone === 'primary' ? 'text-primary' : 'text-bk-900',
        )}
      >
        {Math.round(score)}
      </span>
      <span className="pb-[3px] text-[22px] font-semibold tracking-[-0.11px] text-bk-600">
        / 100
      </span>
    </p>
  );
};
